import { Skeleton } from "antd";
import { Fragment } from "react/jsx-runtime";
import type { IEmployee } from "../../../../app/features/employee/employee.types";
import Section from "../_icons/Section";
import Info from "./Info";

type Props = {
  data?: IEmployee;
  loading?: boolean;
};

export default function ExperienceInfo({ data, loading }: Props) {
  if (loading) {
    return (
      <Section title="চাকুরীর আভিজ্ঞতা" type="experience">
        <Skeleton active paragraph={{ rows: 3 }} />
      </Section>
    );
  }

  return (
    <Section title="চাকুরীর অভিজ্ঞতা" type="experience">
      {data?.experiences?.length ? (
        data.experiences.map((exp, index) => (
          <Fragment key={index}>
            <Info label="চাকুরীর পদবি" value={exp.jobTitle} />
            <Info label="কোম্পানি/প্রতিষ্ঠান" value={exp.company || "N/A"} />
            <Info
              label="কত বছরের অভিজ্ঞতা"
              value={`${exp.totalYears || 0} Years`}
            />
            <Info label="কাজের বিবরণ" value={exp.description || "N/A"} />
          </Fragment>
        ))
      ) : (
        <div className="text-sm text-gray-500">কোন তথ্য নেই</div>
      )}
    </Section>
  );
}
